<template>
    <div class="page-container">
        <Header></Header>

        <div class="msg-header">
            <div class="msg-content">
                <p>any questions ?</p> <br/>
            </div>
        </div>

        <div class="form-div">
        <form class="vue-form" @submit.prevent="sendEmail">

            <div class="error-message">
                <p v-show="!email.valid">Oh, please enter a valid email address.</p>
            </div>

            <fieldset>
                <legend class="legend">drop me a line</legend>
                <div>
                    <label class="label" for="name">name</label>
                    <input type="text" name="user_name" id="name" required="" v-model="name">
                </div>
                <div>
                    <label class="label" for="email">email</label>
                    <input type="email" name="user_email" id="email" required=""
                           :class="{ email , error: !email.valid }"
                           v-model="email.value">
                </div>
                <div>
                    <label class="label" for="textarea">message</label>
                    <textarea class="message" name="message" id="textarea" required=""
                              v-model="message.text"
                              :maxlength="message.maxlength"></textarea>
                    <span class="counter">{{ message.text.length }} / {{ message.maxlength }}</span>
                </div>
                <div>
                    <input class="submit" type="submit" value="Submit">
                </div>
            </fieldset>
        </form>
    </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from "@/components/Header";
    import Footer from "@/components/Footer";
    import emailjs from 'emailjs-com';

    // Regular expression from W3C HTML5.2 input specification:
    // https://www.w3.org/TR/html/sec-forms.html#email-state-typeemail
    var emailRegExp = /^[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

    export default {
        name: "ContactPage",
        components: {Footer, Header},
        data: function() {
            return {
                name: "",
                email: {
                    value: "",
                    valid: true
                },
                message: {
                    text: ``,
                    maxlength: 255
                },
                submitted: false
            };
        },
        methods: {
            sendEmail: (e) => {
                emailjs.sendForm('contact_service', 'contact_form', e.target, 'user_bCwDXgvhcLLjoDDvNYb2d')
                    .then((result) => {
                        console.log('SUCCESS!', result.status, result.text);
                    }, (error) => {
                        console.log('FAILED...', error);
                    });
            },
            submit: function() {
                this.submitted = true;
            },
            // validate by type and value
            validate: function(type, value) {
                if (type === "email") {
                    this.email.valid = this.isEmail(value) ? true : false;
                }
            },
            // check for valid email adress
            isEmail: function(value) {
                return emailRegExp.test(value);
            },
        },
        mounted () {
            window.scrollTo(0, 0)
        },
        watch: {
            // watching nested property
            "email.value": function(value) {
                this.validate("email", value);
            }
        }
    }
</script>

<style scoped>
    @import url("https://fonts.googleapis.com/css?family=Source+Code+Pro:300,400");

    .page-container {
        background: linear-gradient(to left, black, #202020);
        min-height: 100vh;
    }

    .msg-header {
        width: 100vw;
        height: auto;
        margin-top: 100px;
    }

    .msg-content {
        width: 80vw;
        margin-left: auto;
        margin-right: auto;
    }

    .msg-content p {
        font-family: 'Mansalva', cursive;
        color: #FFD700;
        letter-spacing: 10px;
        font-size: 4rem;
    }

    .form-div {
        font-family: 'Roboto', sans-serif;
        color: black;
        letter-spacing: 2px;
        margin-left: -2vw!important;
    }

    .legend {
        font-family: 'Mansalva', cursive;
        letter-spacing: 5px;
        font-size: 3rem;
    }

    .label {
        font-family: 'Mansalva', cursive;
        letter-spacing: 3px;
        font-size: 2rem;
        text-align: left;
        padding-left: 30px;
    }

    a {
        color: #2c3e50;
        text-decoration: none;
    }

    header {
        position: relative;
        height: 150px;
        padding-top: 100px;
    }

    header h1 {
        text-align: center;
        font-size: 2.4rem;
        font-weight: 300;
    }

    .vue-form {
        font-size: 16px;
        max-width: 800px;
        padding: 15px 30px;
        border-radius: 4px;
        margin: 50px auto;
        background-color: #fff;
        box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
    }
    .vue-form fieldset {
        margin: 24px 0 0 0;
    }
    .vue-form legend {
        padding-bottom: 10px;
        border-bottom: 1px solid #ecf0f1;
    }
    .vue-form div {
        position: relative;
        margin: 20px 0;
    }
    .vue-form h4,
    .vue-form .label {
        color: #94aab0;
        margin-bottom: 10px;
    }
    .vue-form .label {
        display: block;
    }
    .vue-form input,
    .vue-form textarea,
    .vue-form label {
        color: #2b3e51;
    }
    .vue-form input[type="text"],
    .vue-form input[type="email"],
    .vue-form textarea,
    .vue-form legend {
        display: block;
        width: 100%;
        appearance: none;
    }
    .vue-form input[type="text"],
    .vue-form input[type="email"],
    .vue-form textarea {
        padding: 12px;
        border: 1px solid #cfd9db;
        background-color: #ffffff;
        border-radius: 0.25em;
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.08);
    }
    .vue-form input[type="text"]:focus,
    .vue-form input[type="email"]:focus,
    .vue-form textarea:focus,
    .vue-form select:focus {
        outline: none;
        border-color: #2c3e50;
        box-shadow: 0 0 5px rgba(44, 151, 222, 0.2);
    }

    .vue-form textarea {
        min-height: 120px;
        resize: vertical;
        overflow: auto;
    }
    .vue-form input[type="submit"] {
        border: none;
        background: #2c3e50;
        border-radius: 0.25em;
        padding: 12px 20px;
        color: #ffffff;
        font-weight: bold;
        float: right;
        cursor: pointer;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        appearance: none;
    }
    .no-touch .vue-form input[type="submit"]:hover {
        background: #42a2e1;
    }
    .vue-form input[type="submit"]:focus {
        outline: none;
        background: #2b3e51;
    }
    .vue-form input[type="submit"]:active {
        transform: scale(0.9);
    }
    .vue-form .error-message {
        height: 35px;
        margin: 0px;
    }
    .vue-form .error-message p {
        background: #e94b35;
        color: #ffffff;
        font-size: 1.4rem;
        text-align: center;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        border-radius: 0.25em;
        padding: 16px;
    }

    .vue-form .counter {
        background-color: #ecf0f1;
        position: absolute;
        right: 0px;
        top: 0px;
        font-size: 10px;
        padding: 4px;
    }

    @-webkit-keyframes cd-bounce {
        0%,
        100% {
            -webkit-transform: scale(1);
        }
        50% {
            -webkit-transform: scale(0.8);
        }
    }
    @-moz-keyframes cd-bounce {
        0%,
        100% {
            -moz-transform: scale(1);
        }
        50% {
            -moz-transform: scale(0.8);
        }
    }
    @keyframes cd-bounce {
        0%,
        100% {
            transform: scale(1);
        }
        50% {
            transform: scale(0.8);
        }
    }

    @media screen and (min-width: 500px) and (max-width: 700px) {
        .msg-content p {
            letter-spacing: 5px;
            font-size: 2.5rem;
        }
    }

    @media screen and (max-width: 499px) {
        .msg-content p {
            letter-spacing: 3px;
            font-size: 2rem;
        }
    }

</style>
